<template>
  <div>
    <div class="box">
      <p class="sub-title">{{ practice.name }}</p>
      <div class="video" v-if="practice && practice.link">
        <video-player
          :key="Math.floor(Math.random() * 10)"
          :videoId="practice.link"
          :resourceId="practice.id"
          :width="500"
          :dropboxLink="getDropboxLink"
        />
      </div>
      <p class="description" v-html="practice.description"></p>
    </div>
  </div>
</template>

<script>
import VideoPlayer from "../../../components/VideoPlayer.vue";
export default {
  components: { VideoPlayer },
  name: "TheoryPracticeLessonPractice",
  props: ["practice", "customKey"],
  methods: {},
  computed: {
    getDropboxLink() {
      let courseLink =
        this.practice && this.practice.link ? this.practice.link : "";
      if (courseLink.includes("dropbox")) {
        const videoLink = courseLink.replace("dl=0", "raw=1");
        return videoLink;
      } else {
        return "";
      }
    },
  },
};
</script>

<style scoped>
.box {
  margin-top: 1rem;
  margin-bottom: 4rem;
  padding: 50px;
  max-width: 100vw !important;
}
.video {
  margin: 0 auto;
  margin-bottom: 2rem;
  max-width: 500px;
}

.description ::v-deep p {
  max-width: 100%;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.description ::v-deep img {
  max-width: min(100%, 500px) !important;
  height: auto !important;
  width: auto !important;
  display: block;
  object-fit: contain;
  margin: 1rem auto;
}

.title {
  font-weight: bold;
}
@media screen and (max-width: 800px) {
  .box {
    padding: 20px;
  }
}
@media screen and (max-width: 500px) {
  .box {
    padding: 0px;
  }
}
</style>
